// extracted by mini-css-extract-plugin
export default {"cold":"badge_cold__5AHs4","hot":"badge_hot__i7h3n","excluded-allergens":"badge_excluded-allergens__stZvl"};